import { useTranslation } from "react-i18next";
import { PcOrderStatus } from "@/hooks/use-pc-orders";

/** Translated labels for PC dashboard order states ("New" / "Ready for Pickup"). */
export function usePcOrderStatusLabel() {
  const { t } = useTranslation();

  return (status: string): string => {
    const labels: Record<PcOrderStatus, string> = {
      new: t("pages.pcOrders.status.new"),
      ready_for_pickup: t("pages.pcOrders.status.readyForPickup"),
    };
    return labels[status as PcOrderStatus] ?? status;
  };
}
